import type { ServerColDef } from '@cmg/data-grid';
import { formatters } from '@cmg/data-grid';

import { JobFunction } from '../../../../../../../../graphql';
import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';

export const jobFunctionColDef: ServerColDef<FirmSalesCoverageGridItemFragment> = {
  field: 'jobFunction',
  headerName: 'Job Function',
  filter: 'agSetColumnFilter',
  valueFormatter: formatters.enumValueFormatter,
  filterParams: {
    values: Object.values(JobFunction),
    valueFormatter: formatters.enumValueFormatter,
  },
};
